import { Link } from "react-router-dom";
import logo from "../../assets/img/HelpMeVoteLogo.svg";

const Header = ({ marquee }) => {

    return (
        <header className="w-full flex flex-col items-center justify-centerspace-y-4">
            {marquee && <div className="relative marquee w-screen h-10 relative bg-gradient-to-r from-emerald-300 via-emerald-700 to-emerald-300 overflow-hidden text-white font-bold">
                    <div className="absolute block inset-x-0 inset-y-0 py-2 overflow-hidden w-[200%] text-lg flex md:animate-[marquee_4s_linear_infinite] animate-[marquee_3s_linear_infinite]">
                    <span className="w-[50%] float-left inline-flex">
                        Lagos LGA Elections will be held on July 12, 2025
                    </span>
                    <span className="w-[50%] float-left">
                        Lagos LGA Elections will be held on July 12, 2025
                    </span>
                </div>
            </div>}
            <Link to={"/"}>
                <div className="flex gap-1 items-end justify-center rounded-full  border-black px-4 py-4">
                    <div className="h-7 w-7">
                        <img src={logo} alt="" />
                    </div>
                    <h2 className="">HelpMeVote.ng</h2>
                </div>
            </Link>
        </header>
    )
}

export default Header;
